module.exports = __webpack_public_path__ + "img/mongoDb.cd62b1e1.svg";